import { makeAutoObservable } from 'mobx';

class ConstantStore {
  RESOURCE_NAME = {
    EXPERIMENTAL: 'Experimental',
    CmSearchMenu: 'CmSearchMenu',
    CmMonth: 'CmMonth',
    CmReportTypeRic: 'CmReportTypeRic',
    CmFrequency: 'CmFrequency',
    CmInfoSystem: 'CmInfoSystem',
    CmImParentOrganizationChild: 'CmImParentOrganizationChild',
    CmImParentOrganization: 'CmImParentOrganization', // Управление головной организацией в справочнике "Организационная структура" в МИ НМ+
    CmReportSettingsAddTemplate: 'CmReportSettingsAddTemplate', // Добавление шаблонов отчетов в систему. Справочник "Настройка отчетов"
    CmReportPackage: 'CmReportPackage', // управление пакетами в Реестре подготовки отчетности
    CmReportPackageStatus: 'CmReportPackageStatus', // управление статусами пакетов в Реестре подготовки отчетности
    CmCalculationRegister: 'CmCalculationRegister', // процесс расчёта регистров в Реестре подготовки отчетности
    CmRunControl: 'CmRunControl', // процесс расчёта контрольных процедур в Реестре подготовки отчетности
    CmControlVersionReport: 'CmControlVersionReport', // функционал добавления КП в пакет
    CmCtrlCompanyReport: 'CmCtrlCompanyReport', // отображение вкладки Прохождение КП в Реестре подготовки отчетности
    TestEmailNotification: 'TestEmailNotification', // отправка тестового сообщения
  };

  RESOURCE_NAME_ROUTES = {
    CmCtrlResults: 'CmCtrlResults', // Контроль данных
    CmReport: 'CmReport', // Обзор справочника "Отчеты"
    CmReportPeriods: 'CmReportPeriods', // Обзор справочника "Группы отчетов"
    CmReportSettings: 'CmReportSettings', // Обзор справочника "Настройка отчетов"
    CmReportVersion: 'CmReportVersion', // Обзор справочника "Версии отчетов"
    CmOrganization: 'CmOrganization', // Обзор справочника "Организационная структура"
    CmControl: 'CmControl', // Обзор справочника "Контроли"
    CmGroupControl: 'CmGroupControl', // Обзор справочника "Группы контролей"
    CmIndicator: 'CmIndicator', // Обзор справочника "Показатели"
    CmControlVersion: 'CmControlVersion', // Обзор справочника "Версии контролей"
    CmControlApplicability: 'CmControlApplicability', // Обзор справочника "Применимости контролей"
    CmPartners: 'CmPartners', // Обзор справочника "Контрагенты"
    CmReportGroup: 'CmReportGroup', // Обзор справочника "Группы отчетности"
    CmEtlProcess: 'CmEtlProcess', // Мониторинг фоновых процессов
    CmPublicationRegister: 'CmPublicationRegister', // Реестр подготовки отчетности
    CmCompanyReport: 'CmCompanyReport', // Просмотр отчетности
    CmWorkplace: 'CmWorkplace', // Личный кабинет
    CmAdministration: 'CmAdministration',
    CmUserDataFilter: 'CmUserDataFilter', // Настройка ролей пользователей
    CmSettings: 'CmSettings', // Вкладка Общие настройки
  };

  ALL_RESOURCE_NAME = { ...this.RESOURCE_NAME_ROUTES, ...this.RESOURCE_NAME };

  constructor() {
    makeAutoObservable(this);
  }

  TABLE_NAMES = {
    AUDIT: 'audit',
    LOGS: 'logs',
    LOGS_DETAILS: 'logsDetails',
    ORGANIZATION_CARD_SOUN: 'organizationCardSoun',
    DICTIONARY_REPORT_SETTINGS: 'dictionaryReportSettings',
    DICTIONARY_REPORT_VERSION: 'dictionaryReportVersion',
    DICTIONARY_REPORT_PERIODS: 'dictionaryReportPeriods',
    DICTIONARY_REPORT: 'dictionaryReport',
    DICTIONARY_REPORT_GROUPS: 'dictionaryReportGroups',
    DICTIONARY_CONTROLS: 'dictionaryControls',
    DICTIONARY_CONTROL_GROUPS: 'dictionaryControlGroups',
    DICTIONARY_INDICATORS: 'dictionaryIndicators',
    DICTIONARY_INDICATOR_RULES: 'dictionaryIndicatorRules',
    DICTIONARY_CONTROL_VERSIONS: 'dictionaryControlVersions',
    DICTIONARY_CONTROL_STEPS: 'dictionaryControlSteps',
    DICTIONARY_CONTROL_APPLICABILITY: 'dictionaryControlApplicability',
    DICTIONARY_COUNTERPARTIES: 'dictionaryCounterparties',
    REPORTING_FORM_FIVE: 'reportingFormFive',
    PUBLICATION_REGISTER: 'publicationRegister',
    PASSING_CONTROL: 'passingControl',
    PUBLICATION_REJECT_REPORT_MODAL: 'publicationRejectReportModal',
    GENERAL_REPORT: 'generalReport',
    PACKAGE_LEVEL: 'packageLevel',
    CONTROL_LEVEL: 'controlLevel',
    STEP_LEVEL: 'stepLevel',
    ERROR_DETAILS: 'ErrorDetails',
    LAUNCHES_MODAL: 'LaunchesModal',
    USER_ROLE_REPORT: 'userRoleReport',
    SETTING_USER_ROLES: 'settingUserRoles',
  };

  REPORT_PACKAGE_STATUS = {
    CREATE: 'Создан',
    PUBLISHED: 'Утвержден',
    FOR_APPROVAL: 'На утверждении',
    NEEDS_IMPROVEMENT: 'Требует доработки',
    PREPARED: 'Подготовлен',
  };

  COUNTERPARTY_TYPES = {
    DEFAULT_CODE: 'U',
  };
}

export const constantStore = new ConstantStore();
